import { VStack } from "@chakra-ui/react"
import React from "react"
import { GenerateComprehensiveUserAttendanceReportForm } from "../../../forms"

export const GenerateComprehensiveUserAttendanceReport: React.FC = () => {
	return (
		<VStack w="full" spacing={6}>
			<GenerateComprehensiveUserAttendanceReportForm />
		</VStack>
	)
}
